import {
  CurrencyPipe,
  NgClass,
  NgFor,
  NgIf,
  NgOptimizedImage,
} from '@angular/common';
import { Component, Input } from '@angular/core';
import { TitleExtractorPipe } from 'src/app/pipe/product-title.pipe';
import { EnvironmentService } from 'src/app/service/environment.service';
import { BadgeComponent } from '../../collection-item/badge/badge.component';
import { AddToCartComponent } from './add-to-cart/add-to-cart.component';

@Component({
  selector: 'app-upsell-item',
  imports: [
    BadgeComponent,
    NgClass,
    NgIf,
    NgFor,
    NgOptimizedImage,
    TitleExtractorPipe,
    CurrencyPipe,
    AddToCartComponent,
  ],
  templateUrl: './upsell-item.component.html',
  styleUrl: './upsell-item.component.scss',
})
export class UpsellItemComponent {
  @Input() product: any;
  currency: string;
  constructor(private environmentService: EnvironmentService) {
    this.currency = this.environmentService.environment.currency;
  }
}
